export default __webpack_public_path__ + "static/media/DSC09803.d8e3c339.JPG";